// Top-level tabs for the program enrollments list (§6.3). The tab acts as a
// coarse status filter; only the "all" tab exposes the fine-grained status /
// source / sort filters. `status === null` means "don't force a status" (the
// "all" tab defers to the user-controlled ChipPicker filters).
export const ENROLLMENT_TABS = [
  { key: "all", label: "Todos os mentorados", status: null },
  { key: "active", label: "Mentoria em progresso", status: ["active"] },
  { key: "pending", label: "Aguardando aprovação", status: ["pending"] },
];

export const DEFAULT_ENROLLMENT_TAB = "all";

// Tab key → forced status list (or null for the "all" tab).
export const ENROLLMENT_TAB_STATUS = ENROLLMENT_TABS.reduce(
  (acc, tab) => ({ ...acc, [tab.key]: tab.status }),
  {}
);

// The tab the pending-approvals card / count badge points at.
export const PENDING_TAB = "pending";
